import axios from "axios"
import {
  ReportsData,
  SectionOptions,
} from "../reducers/reportsReducer/@types"
import qs from "qs"

export const reportsAPI = {
  // fetchReports: async (input: {
  //   apiGatewayUrl: string
  //   token: string
  //   projectId: string
  //   year: string
  //   month: string
  // }) => {
  //   const { apiGatewayUrl, token, year, month, projectId } = input
  //   const res = await axios.post(
  //     `${apiGatewayUrl}/reports/`,
  //     {
  //       projectId,
  //       year,
  //       month,
  //     },
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     }
  //   )
  //   return res.data as { [zoneId: string]: ReportsData }
  // },

  //DCM-995: New query endpoint: uses lambdas
  fetchReports: async (input: {
    reportsUrl: string
    token: string
    projectId: string
    year: string
    month: string
  }) => {
    const { reportsUrl, token, year, month, projectId } = input
    const res = await axios.get(
      `${reportsUrl}/reports/${projectId}/?${qs.stringify({ year, month })}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res.data as { [zoneId: string]: ReportsData }
  },
  /**
   * Gets day reports data
   */
  getDayReports: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    offset: string
    hourStart: number
    hourEnd: number
    projectId: string
    zoneIds: string[]
    calibrationIds: string[]
    sections: SectionOptions
    token: string
  }) => {
    const {
      reportsApiGatewayUrl, startdate, offset, projectId,
      zoneIds, calibrationIds, token, hourStart, hourEnd, sections
    } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/day`,
      {
        projectId,
        zoneIds,
        calibrationIds,
        startdate,
        offset,
        hourStart,
        hourEnd,
        sections,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets day report data for a window of time
   */
  getDayWindowReports: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    enddate: string
    offset: string
    hourStart: number
    hourEnd: number
    projectId: string
    zoneIds: string[]
    calibrationIds: string[]
    sections: SectionOptions
    token: string
  }) => {
    const {
      reportsApiGatewayUrl, startdate, enddate, offset, projectId,
      zoneIds, calibrationIds, token, hourStart, hourEnd, sections
    } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/day/window`,
      {
        projectId,
        zoneIds,
        calibrationIds,
        startdate,
        enddate,
        offset,
        hourStart,
        hourEnd,
        sections,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets week reports data
   */
  getWeekReports: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    offset: string
    hourStart: number
    hourEnd: number
    projectId: string
    zoneIds: string[]
    calibrationIds: string[]
    sections: SectionOptions
    token: string
  }) => {
    const {
      reportsApiGatewayUrl, startdate, offset, projectId, zoneIds,
      calibrationIds, token, hourStart, hourEnd, sections
    } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/week`,
      {
        projectId,
        zoneIds,
        calibrationIds,
        startdate,
        offset,
        hourStart,
        hourEnd,
        sections,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets month reports data
   */
  getMonthReports: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    offset: string
    hourStart: number
    hourEnd: number
    projectId: string
    zoneIds: string[]
    calibrationIds: string[]
    sections: SectionOptions
    token: string
  }) => {
    const {
      reportsApiGatewayUrl, startdate, offset, projectId, zoneIds,
      calibrationIds, token, hourStart, hourEnd, sections
    } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/month`,
      {
        projectId,
        zoneIds,
        calibrationIds,
        startdate,
        offset,
        hourStart,
        hourEnd,
        sections
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Checks which metrics have data for project
   */
  hasMetricData: async (input: {
    reportsApiGatewayUrl: string
    projectId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, projectId, token } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/hasMetricData`,
      { projectId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets crowd capacity reports data
   */
  getCrowdCapacityData: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    enddate: string
    interval: number
    projectId: string
    reportId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, startdate, enddate, interval, projectId, reportId, token } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/crowdcapacity/get/${projectId}`,
      {
        startdate,
        enddate,
        interval,
        reportId
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Creates and returns crowd capacity reports data
   */
  createCrowdCapacityData: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    enddate: string
    reportId: string
    projectId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, startdate, enddate, projectId, reportId, token } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/crowdcapacity/create/${projectId}`,
      {
        startdate,
        enddate,
        reportId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Creates and returns a crowd capacity report
   */
  createCrowdCapacityReport: async (input: {
    reportsApiGatewayUrl: string
    reportName: string
    aggregateFunction: string
    areas: any[]
    projectId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, reportName, aggregateFunction, areas, projectId, token } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/crowdcapacity/report/create/${projectId}`,
      {
        reportName,
        aggregateFunction,
        areas,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets a crowd capacity report
   */
  getCrowdCapacityReport: async (input: {
    reportsApiGatewayUrl: string
    reportId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, reportId, token } = input
    const res = await axios.get(
      `${reportsApiGatewayUrl}/crowdcapacity/report/${reportId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Updates a crowd capacity report
   */
  updateCrowdCapacityReport: async (input: {
    reportsApiGatewayUrl: string
    reportId: string
    reportName: string
    aggregateFunction: string
    areas: any[]
    token: string
  }) => {
    const { reportsApiGatewayUrl, reportId, reportName, aggregateFunction, areas, token } = input
    const res = await axios.put(
      `${reportsApiGatewayUrl}/crowdcapacity/report/${reportId}`,
      {
        reportName,
        aggregateFunction,
        areas,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Deletes a crowd capacity report
   */
  deleteCrowdCapacityReport: async (input: {
    reportsApiGatewayUrl: string
    reportId: string
    token: string
  }) => {
    const { reportsApiGatewayUrl, reportId, token } = input
    const res = await axios.delete(
      `${reportsApiGatewayUrl}/crowdcapacity/report/${reportId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
  },
  /**
   * Gets cumulative counting reports data
   */
  getCumulativeCountsData: async (input: {
    reportsApiGatewayUrl: string
    startdate: string
    enddate: string
    interval: number
    projectId: string
    calibrationIds: string[]
    token: string
  }) => {
    const { reportsApiGatewayUrl, startdate, enddate, interval, projectId, calibrationIds, token } = input
    const res = await axios.post(
      `${reportsApiGatewayUrl}/cumulativecounts/get/${projectId}`,
      {
        startdate,
        enddate,
        interval,
        calibrationIds
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    return res;
    // const d = JSON.parse('[{"timestamp":"2023-08-31T02:43:00.000Z","count":-226,"calibrationId":3},{"timestamp":"2023-08-31T02:44:00.000Z","count":-106,"calibrationId":3},{"timestamp":"2023-08-31T02:45:00.000Z","count":-64,"calibrationId":3},{"timestamp":"2023-08-31T02:46:00.000Z","count":-23,"calibrationId":3},{"timestamp":"2023-08-31T02:47:00.000Z","count":-4,"calibrationId":3},{"timestamp":"2023-08-31T02:48:00.000Z","count":-125,"calibrationId":3},{"timestamp":"2023-08-31T02:49:00.000Z","count":-77,"calibrationId":3},{"timestamp":"2023-08-31T02:50:00.000Z","count":-20,"calibrationId":3},{"timestamp":"2023-08-31T02:54:00.000Z","count":-74,"calibrationId":3},{"timestamp":"2023-08-31T02:55:00.000Z","count":-300,"calibrationId":3},{"timestamp":"2023-08-31T02:56:00.000Z","count":-295,"calibrationId":3},{"timestamp":"2023-08-31T02:57:00.000Z","count":-23,"calibrationId":3},{"timestamp":"2023-08-31T03:00:00.000Z","count":-96,"calibrationId":3},{"timestamp":"2023-08-31T03:01:00.000Z","count":-224,"calibrationId":3},{"timestamp":"2023-08-31T03:21:00.000Z","count":-31,"calibrationId":3},{"timestamp":"2023-08-31T03:22:00.000Z","count":-354,"calibrationId":3},{"timestamp":"2023-08-31T03:24:00.000Z","count":-32,"calibrationId":3},{"timestamp":"2023-08-31T03:25:00.000Z","count":-69,"calibrationId":3},{"timestamp":"2023-08-31T03:26:00.000Z","count":-50,"calibrationId":3},{"timestamp":"2023-08-31T03:27:00.000Z","count":-24,"calibrationId":3},{"timestamp":"2023-08-31T03:28:00.000Z","count":-19,"calibrationId":3},{"timestamp":"2023-08-31T03:29:00.000Z","count":-71,"calibrationId":3},{"timestamp":"2023-08-31T03:30:00.000Z","count":-56,"calibrationId":3},{"timestamp":"2023-08-31T03:31:00.000Z","count":-255,"calibrationId":3},{"timestamp":"2023-08-31T03:32:00.000Z","count":-381,"calibrationId":3},{"timestamp":"2023-08-31T03:33:00.000Z","count":-269,"calibrationId":3},{"timestamp":"2023-08-31T03:34:00.000Z","count":-376,"calibrationId":3},{"timestamp":"2023-08-31T03:35:00.000Z","count":-292,"calibrationId":3},{"timestamp":"2023-08-31T03:36:00.000Z","count":-235,"calibrationId":3},{"timestamp":"2023-08-31T03:37:00.000Z","count":-96,"calibrationId":3},{"timestamp":"2023-08-31T03:38:00.000Z","count":-160,"calibrationId":3},{"timestamp":"2023-08-31T03:39:00.000Z","count":-83,"calibrationId":3},{"timestamp":"2023-08-31T03:40:00.000Z","count":-46,"calibrationId":3},{"timestamp":"2023-08-31T03:41:00.000Z","count":-74,"calibrationId":3},{"timestamp":"2023-08-31T03:42:00.000Z","count":-129,"calibrationId":3},{"timestamp":"2023-08-31T03:43:00.000Z","count":-117,"calibrationId":3},{"timestamp":"2023-08-31T03:44:00.000Z","count":-58,"calibrationId":3},{"timestamp":"2023-08-31T03:45:00.000Z","count":-45,"calibrationId":3},{"timestamp":"2023-08-31T03:46:00.000Z","count":-103,"calibrationId":3},{"timestamp":"2023-08-31T03:47:00.000Z","count":-62,"calibrationId":3},{"timestamp":"2023-08-31T03:48:00.000Z","count":-272,"calibrationId":3},{"timestamp":"2023-08-31T03:49:00.000Z","count":-131,"calibrationId":3},{"timestamp":"2023-08-31T03:50:00.000Z","count":-65,"calibrationId":3},{"timestamp":"2023-08-31T03:51:00.000Z","count":-56,"calibrationId":3},{"timestamp":"2023-08-31T03:52:00.000Z","count":-55,"calibrationId":3},{"timestamp":"2023-08-31T03:53:00.000Z","count":-210,"calibrationId":3},{"timestamp":"2023-08-31T03:54:00.000Z","count":-58,"calibrationId":3},{"timestamp":"2023-08-31T03:55:00.000Z","count":-205,"calibrationId":3},{"timestamp":"2023-08-31T03:56:00.000Z","count":-54,"calibrationId":3},{"timestamp":"2023-08-31T03:59:00.000Z","count":-12,"calibrationId":3},{"timestamp":"2023-08-31T04:00:00.000Z","count":-85,"calibrationId":3},{"timestamp":"2023-08-31T04:01:00.000Z","count":-60,"calibrationId":3},{"timestamp":"2023-08-31T04:02:00.000Z","count":-80,"calibrationId":3},{"timestamp":"2023-08-31T04:03:00.000Z","count":-86,"calibrationId":3},{"timestamp":"2023-08-31T04:04:00.000Z","count":-59,"calibrationId":3},{"timestamp":"2023-08-31T04:05:00.000Z","count":-55,"calibrationId":3},{"timestamp":"2023-08-31T04:06:00.000Z","count":-59,"calibrationId":3},{"timestamp":"2023-08-31T04:07:00.000Z","count":-149,"calibrationId":3},{"timestamp":"2023-08-31T04:08:00.000Z","count":-295,"calibrationId":3},{"timestamp":"2023-08-31T04:09:00.000Z","count":-141,"calibrationId":3},{"timestamp":"2023-08-31T04:10:00.000Z","count":-56,"calibrationId":3},{"timestamp":"2023-08-31T04:11:00.000Z","count":-29,"calibrationId":3},{"timestamp":"2023-08-31T04:12:00.000Z","count":-24,"calibrationId":3},{"timestamp":"2023-08-31T04:19:00.000Z","count":-112,"calibrationId":3},{"timestamp":"2023-08-31T04:20:00.000Z","count":-318,"calibrationId":3},{"timestamp":"2023-08-31T04:22:00.000Z","count":-40,"calibrationId":3},{"timestamp":"2023-08-31T04:23:00.000Z","count":-53,"calibrationId":3},{"timestamp":"2023-08-31T04:24:00.000Z","count":-28,"calibrationId":3}]');
    // const d = JSON.parse('[{"timestamp":"2023-08-31T02:43:00.000Z","positive":2,"negative":-228,"calibrationId":3},{"timestamp":"2023-08-31T02:44:00.000Z","positive":8,"negative":-114,"calibrationId":3},{"timestamp":"2023-08-31T02:45:00.000Z","positive":0,"negative":-64,"calibrationId":3},{"timestamp":"2023-08-31T02:46:00.000Z","positive":0,"negative":-23,"calibrationId":3},{"timestamp":"2023-08-31T02:47:00.000Z","positive":0,"negative":-4,"calibrationId":3},{"timestamp":"2023-08-31T02:48:00.000Z","positive":4,"negative":-129,"calibrationId":3},{"timestamp":"2023-08-31T02:49:00.000Z","positive":0,"negative":-77,"calibrationId":3},{"timestamp":"2023-08-31T02:50:00.000Z","positive":0,"negative":-20,"calibrationId":3},{"timestamp":"2023-08-31T02:54:00.000Z","positive":4,"negative":-78,"calibrationId":3},{"timestamp":"2023-08-31T02:55:00.000Z","positive":10,"negative":-310,"calibrationId":3},{"timestamp":"2023-08-31T02:56:00.000Z","positive":22,"negative":-317,"calibrationId":3},{"timestamp":"2023-08-31T02:57:00.000Z","positive":0,"negative":-23,"calibrationId":3},{"timestamp":"2023-08-31T03:00:00.000Z","positive":0,"negative":-96,"calibrationId":3},{"timestamp":"2023-08-31T03:01:00.000Z","positive":8,"negative":-232,"calibrationId":3},{"timestamp":"2023-08-31T03:21:00.000Z","positive":0,"negative":-31,"calibrationId":3},{"timestamp":"2023-08-31T03:22:00.000Z","positive":10,"negative":-364,"calibrationId":3},{"timestamp":"2023-08-31T03:24:00.000Z","positive":0,"negative":-32,"calibrationId":3},{"timestamp":"2023-08-31T03:25:00.000Z","positive":0,"negative":-69,"calibrationId":3},{"timestamp":"2023-08-31T03:26:00.000Z","positive":0,"negative":-50,"calibrationId":3},{"timestamp":"2023-08-31T03:27:00.000Z","positive":2,"negative":-26,"calibrationId":3},{"timestamp":"2023-08-31T03:28:00.000Z","positive":0,"negative":-19,"calibrationId":3},{"timestamp":"2023-08-31T03:29:00.000Z","positive":2,"negative":-73,"calibrationId":3},{"timestamp":"2023-08-31T03:30:00.000Z","positive":0,"negative":-56,"calibrationId":3},{"timestamp":"2023-08-31T03:31:00.000Z","positive":6,"negative":-261,"calibrationId":3},{"timestamp":"2023-08-31T03:32:00.000Z","positive":7,"negative":-388,"calibrationId":3},{"timestamp":"2023-08-31T03:33:00.000Z","positive":10,"negative":-279,"calibrationId":3},{"timestamp":"2023-08-31T03:34:00.000Z","positive":8,"negative":-384,"calibrationId":3},{"timestamp":"2023-08-31T03:35:00.000Z","positive":8,"negative":-300,"calibrationId":3},{"timestamp":"2023-08-31T03:36:00.000Z","positive":10,"negative":-245,"calibrationId":3},{"timestamp":"2023-08-31T03:37:00.000Z","positive":0,"negative":-96,"calibrationId":3},{"timestamp":"2023-08-31T03:38:00.000Z","positive":6,"negative":-166,"calibrationId":3},{"timestamp":"2023-08-31T03:39:00.000Z","positive":1,"negative":-84,"calibrationId":3},{"timestamp":"2023-08-31T03:40:00.000Z","positive":4,"negative":-50,"calibrationId":3},{"timestamp":"2023-08-31T03:41:00.000Z","positive":5,"negative":-79,"calibrationId":3},{"timestamp":"2023-08-31T03:42:00.000Z","positive":0,"negative":-129,"calibrationId":3},{"timestamp":"2023-08-31T03:43:00.000Z","positive":4,"negative":-121,"calibrationId":3},{"timestamp":"2023-08-31T03:44:00.000Z","positive":1,"negative":-59,"calibrationId":3},{"timestamp":"2023-08-31T03:45:00.000Z","positive":2,"negative":-47,"calibrationId":3},{"timestamp":"2023-08-31T03:46:00.000Z","positive":2,"negative":-105,"calibrationId":3},{"timestamp":"2023-08-31T03:47:00.000Z","positive":0,"negative":-62,"calibrationId":3},{"timestamp":"2023-08-31T03:48:00.000Z","positive":4,"negative":-276,"calibrationId":3},{"timestamp":"2023-08-31T03:49:00.000Z","positive":5,"negative":-136,"calibrationId":3},{"timestamp":"2023-08-31T03:50:00.000Z","positive":7,"negative":-72,"calibrationId":3},{"timestamp":"2023-08-31T03:51:00.000Z","positive":0,"negative":-56,"calibrationId":3},{"timestamp":"2023-08-31T03:52:00.000Z","positive":0,"negative":-55,"calibrationId":3},{"timestamp":"2023-08-31T03:53:00.000Z","positive":6,"negative":-216,"calibrationId":3},{"timestamp":"2023-08-31T03:54:00.000Z","positive":0,"negative":-58,"calibrationId":3},{"timestamp":"2023-08-31T03:55:00.000Z","positive":6,"negative":-211,"calibrationId":3},{"timestamp":"2023-08-31T03:56:00.000Z","positive":2,"negative":-56,"calibrationId":3},{"timestamp":"2023-08-31T03:59:00.000Z","positive":0,"negative":-12,"calibrationId":3},{"timestamp":"2023-08-31T04:00:00.000Z","positive":2,"negative":-87,"calibrationId":3},{"timestamp":"2023-08-31T04:01:00.000Z","positive":2,"negative":-62,"calibrationId":3},{"timestamp":"2023-08-31T04:02:00.000Z","positive":1,"negative":-81,"calibrationId":3},{"timestamp":"2023-08-31T04:03:00.000Z","positive":7,"negative":-93,"calibrationId":3},{"timestamp":"2023-08-31T04:04:00.000Z","positive":0,"negative":-59,"calibrationId":3},{"timestamp":"2023-08-31T04:05:00.000Z","positive":0,"negative":-55,"calibrationId":3},{"timestamp":"2023-08-31T04:06:00.000Z","positive":0,"negative":-59,"calibrationId":3},{"timestamp":"2023-08-31T04:07:00.000Z","positive":4,"negative":-153,"calibrationId":3},{"timestamp":"2023-08-31T04:08:00.000Z","positive":9,"negative":-304,"calibrationId":3},{"timestamp":"2023-08-31T04:09:00.000Z","positive":1,"negative":-142,"calibrationId":3},{"timestamp":"2023-08-31T04:10:00.000Z","positive":2,"negative":-58,"calibrationId":3},{"timestamp":"2023-08-31T04:11:00.000Z","positive":0,"negative":-29,"calibrationId":3},{"timestamp":"2023-08-31T04:12:00.000Z","positive":0,"negative":-24,"calibrationId":3},{"timestamp":"2023-08-31T04:19:00.000Z","positive":0,"negative":-112,"calibrationId":3},{"timestamp":"2023-08-31T04:20:00.000Z","positive":10,"negative":-328,"calibrationId":3},{"timestamp":"2023-08-31T04:22:00.000Z","positive":0,"negative":-40,"calibrationId":3},{"timestamp":"2023-08-31T04:23:00.000Z","positive":0,"negative":-53,"calibrationId":3},{"timestamp":"2023-08-31T04:24:00.000Z","positive":2,"negative":-30,"calibrationId":3}]');
    // return { data: d };
  },
}
